export default __webpack_public_path__ + "static/media/jabat-tangan.abc0e602.png";